import { alpha, styled } from '@mui/material';

export const Video = styled('video')(({ theme }) => ({
    width: '19.25rem',
    height: '10.625rem',
    flexShrink: 0,
    borderRadius: theme.typography.borderRadius.xxSmall,
    border: `1px solid ${alpha(theme.palette.text.primary, 0.5)}`,
    background: theme.palette.black[400],

    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
}));

export const PlayIconBtnBox = styled('button')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
    border: 'unset',
    background: 'unset',
}));
